import { render, staticRenderFns } from "./r-tab.vue?vue&type=template&id=7822046e"
import script from "./r-tab.vue?vue&type=script&lang=js"
export * from "./r-tab.vue?vue&type=script&lang=js"
import style0 from "./r-tab.vue?vue&type=style&index=0&id=7822046e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports